import { PLAN_LABELS } from 'common/constant';
import React from 'react';
import { ModalForm, renderAlertMessage, buttonStatus } from './modals-utils';

export const ThankYouAccountModal = ({
    onCloseDialogs,
    formData,
    onChange,
    register,
    setFormData
}) => {
    const title = 'Create your “Thank You” account';
    return (
        <div id="checkout-free-modal" className="checkout-free-modal">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 checkout-plans-content">
                        <ModalForm
                            title={title}
                            renderAlertMessage={renderAlertMessage}
                            formData={formData}
                            setFormData={setFormData}
                            onChange={onChange}
                            register={register}
                            buttonStatus={buttonStatus}
                        />
                        <div className="checkout-plans__information">
                            <div className="checkout-plans__information-header">
                                <h3>
                                    “{PLAN_LABELS.LOYALTY}”
                                    <span>On the house</span>
                                </h3>
                                <button
                                    className="btn btn-close-checkout"
                                    onClick={() => onCloseDialogs()}>
                                    <i className="icon-times-light" />
                                </button>
                            </div>
                            <ul className="checkout-plans__information-list">
                                <li>1 TB of storage</li>
                                <li>12 PDF Downloads per year</li>
                                <li>Shared Entries & Journals</li>
                                <li>25% Discount on JRNL Purchases</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
